import { AfterContentInit, Directive, ElementRef, input } from '@angular/core';
import { AntragHelperService } from '../antrags-overview';
import { BescheideService } from '../providers';
import { RouteableSubfeature } from '../models';
import { lastValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';

@Directive({
  selector: '[eBeihilfeTileSubfeature]',
  standalone: true,
})
export class DynamicSubfeatureDirective implements AfterContentInit {
  public eBeihilfeTileSubfeature = input.required<RouteableSubfeature>();

  constructor(
    private readonly elRef: ElementRef<HTMLElement>,
    private readonly antragHelper: AntragHelperService,
    private readonly bescheide: BescheideService,
  ) {}

  public setHidden(): void {
    const el = this.elRef.nativeElement;
    el.style.visibility = 'hidden';
  }

  public setContentInHtmlElement(val: number): void {
    const el = this.elRef.nativeElement;
    el.innerText = val.toString();
    el.style.visibility = val === 0 ? 'hidden' : 'visible';

    const label = el.getAttribute('aria-label');
    if (label) {
      el.setAttribute('aria-label', `${label} ${val}`);
    }
  }

  public async ngAfterContentInit(): Promise<void> {
    this.setHidden();
    switch (this.eBeihilfeTileSubfeature()) {
      case 'FINISHED_ANTRAGE_COUNT': {
        const finishedAntrageCount = await this.antragHelper.getFinishedAntragCount();
        this.setContentInHtmlElement(finishedAntrageCount);
        break;
      }

      case 'UNFINISHED_ANTRAGE_COUNT': {
        const unfinishedAntraegeCount = await this.antragHelper.getDraftCount();
        this.setContentInHtmlElement(unfinishedAntraegeCount);
        break;
      }

      case 'UNREAD_BESCHEIDE': {
        const unreadCount = await lastValueFrom(this.bescheide.getCountOfNewBescheide());

        this.setContentInHtmlElement(unreadCount);
        break;
      }

      case 'TOTAL_COUNT_BESCHEIDE': {
        const allReadableBescheide = await lastValueFrom(
          this.bescheide
            .getBescheide()
            .pipe(map((bescheide) => bescheide.filter((bescheid) => bescheid.tokenState !== 'NA').length)),
        );

        this.setContentInHtmlElement(allReadableBescheide);
        break;
      }
    }
  }
}
